(ns iris.censors.route-data
  (:require
   [iris.censors.events :as censors-events]))


(defn- route-params [route]
  (get-in route [:route :route-params]))


(defn- query-params [route]
  (or (get-in route [:route :query-params]) {}))


(defn censors-query-params [db route]
  (assoc (query-params route)
         :clear-form? (boolean (get-in db [:censors :form-data :ruid]))))


(defn censors-load-key [query-params]
  (select-keys query-params [:q :limit :page :order :scope]))


(defn censors-effects [{:keys [q clear-form?] :as query-params}]
  (cond-> [(if q
             [::censors-events/http-search-censor-list query-params]
             [::censors-events/http-get-censor-list query-params])]
    clear-form? (conj [::censors-events/reset-form-data])))


(defn censors-edit-query-params [_db route]
  (when-let [id (:id (route-params route))]
    {:id id}))


(defn censors-edit-load-key [query-params]
  query-params)


(defn censors-edit-effects [{:keys [id]}]
  [[::censors-events/http-get-censor-rule id]])


(defn censors-create-new-query-params [_db route]
  {:scope (:scope (query-params route))})


(defn censors-create-new-load-key [query-params]
  query-params)


(defn censors-create-new-effects [{:keys [scope]}]
  [(if scope
     [::censors-events/reset-form-data {:scopes_input scope}]
     [::censors-events/reset-form-data])])


(def panel-loaders
  {:censors-panel
   {:params-fn   censors-query-params
    :load-key-fn censors-load-key
    :effects-fn  censors-effects}

   :censors-edit-panel
   {:params-fn   censors-edit-query-params
    :load-key-fn censors-edit-load-key
    :effects-fn  censors-edit-effects}

   :censors-create-new-panel
   {:params-fn   censors-create-new-query-params
    :load-key-fn censors-create-new-load-key
    :effects-fn  censors-create-new-effects}})
